import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    width: '220',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Office Code',
    field: 'officeCode',
    filter: 'text',
    width: '120',
    searchable: true,
  },
  {
    title: 'Builder Code',
    field: 'builderCode',
    filter: 'text',
    width: '130',
    searchable: true,
  },
  {
    title: 'Account Manager',
    field: 'accountManagerNames',
    filter: 'text',
    width: '160',
    searchable: true,
  },
  {
    title: 'Office Type',
    field: 'officeTypeName',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Created Date',
    field: 'createdOn',
    filter: 'text',
    width: '140',
    searchable: true,
  },

  {
    title: 'Contracts',
    field: 'contracts',
    filter: 'numeric',
    width: '150',
    searchable: true,
  },
  {
    title: 'Contacts',
    field: 'contacts',
    filter: 'numeric',
    searchable: true,
    width: '200',
  },
  {
    title: 'Projects',
    field: 'projects',
    filter: 'numeric',
    searchable: true,
    width: '250',
  },
  {
    title: 'Lots/Units',
    field: 'lots',
    filter: 'numeric',
    searchable: true,
    width: '150',
  },
  // {
  //   title: 'Plans',
  //   field: 'plansCount',
  //   filter: 'numeric',
  //   searchable: true,
  //   width: '130',
  // },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    width: '130',
    searchable: true,
  },
];
